import React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Footer from "../components/footer/Footer";
import Header from "../components/header/Normal/Header";
import Home from "../pages/home/Home";

// अलग-अलग फोल्डर से इम्पोर्ट



import { isLoggedIn } from "../config/utils";

import ContactUs from "pages/contact/ContactUs";




import NotFound from "pages/notfound/Notfound";
import Services from "pages/serviceslist/Services";
import ServiceDetails from "pages/serviceslist/ServiceDetails";

import BlogDetail from "pages/blog/BlogDetail";
import GalleryPage from "pages/gallery/GalleryPage";
import DynamicPage from "pages/home/DynamicPage/dynamicPage";
import AboutUs from "pages/about/AboutUs"
import BlocksPage from "pages/blog/Blog";
import CareersPage from "pages/careers/CareersPage";

// import TopBar from "components/header/Normal/Topbar";

const NormalHeaderOutlet = () => (
  <>
    {/* <TopBar /> */}
    <Header />

    <Outlet />
    <Footer />
  </>
);

// route

const Routing = () => {
  return (
    <section className="routing">
      <Routes>
        <Route element={<NormalHeaderOutlet />}>


          <Route path="/" element={<Home />} />

          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/service/:id" element={<ServiceDetails />} />
          <Route path="/blogs" element={<BlocksPage />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/gallery" element={<GalleryPage />} />
           <Route path="/:dynamicpage" element={<DynamicPage />} />
           <Route path="/careers" element={<CareersPage />} />

        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </section>
  );
};

export default Routing; 